import React, { useEffect, useRef, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import TimetableChart from "../components/TimetableChart";
import {functions} from "../constants/common-functions";
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";
import {OMNISCAN_CORPORATE_TURQUOIS} from "../constants/colors";
import {OMNISCAN_CORPORATE_GREEN} from "../constants/colors";
import {OMNISCAN_CORPORATE_RED} from "../constants/colors";
import {OMNISCAN_CORPORATE_PINK} from "../constants/colors";
import {OMNISCAN_CORPORATE_PURPLE} from "../constants/colors";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/colors";
import {COLOR_DASHBOARD_BACKGROUND} from "../constants/colors";
import {useHistory} from 'react-router-dom';
import {BASE_SELECT_FIRST_OPTION} from "../constants/styles";
import {BASE_INPUT_ROW} from "../constants/styles";
import {BASE_LABEL} from "../constants/styles";
import {BASE_SELECT} from "../constants/styles";
import {BASE_BUTTON} from "../constants/styles";
import {STRINGIFY} from "../constants/general-constants";
import {CARD_STYLE} from "../constants/styles";
import {CHART_CONTAINER_STYLE} from "../constants/styles";
import {NON_HERO_BACKGROUND} from "../constants/styles";

am4core.useTheme(am4themes_animated);

export default function TimetableDashboard() {
	
	const history = useHistory();
	
	const refTeachingWeek = useRef(null);
	const refSizeBand = useRef(null);
	const refDayOfWeek = useRef(null);
	const refHourOfDay = useRef(null);
	const refFaculty = useRef(null);
	const refDepartment = useRef(null);
	
	const PROCESS_TYPE_COUNT = 0;
	const PROCESS_TYPE_SUM = 1;
	
	
	const [dataAnnualExams, setDataAnnualExams] = useState([]);
	const [dataDayOfWeekExams, setDataDayOfWeekExams] = useState([]);
	const [dataHourOfDayExams, setDataHourOfDayExams] = useState([]);
	const [dataSizeBandExams, setDataSizeBandExams] = useState([]);
	const [dataFacultyExams, setDataFacultyExams] = useState([]);
	
	const [processType, setProcessType] = useState(PROCESS_TYPE_COUNT);
	const [showExams, setShowExams] = useState(false);
	
	const [maxCount, setMaxCount] = useState({});
	const [maxSum, setMaxSum] = useState({});
	const [minCount, setMinCount] = useState({});
	const [minSum, setMinSum] = useState({});
	
	const [teachingWeeks, setTeachingWeeks] = useState([]);
	const [faculties, setFaculties] = useState([]);
	const [departments, setDepartments] = useState([]);
	
	const [loaded, setLoaded] = useState(false);
	
	const [selectedTeachingWeekId, setSelectedTeachingWeekId]= useState(-100);
	const [selectedHourOfDay, setSelectedHourOfDay] = useState(-100);
	const [selectedDayOfWeek, setSelectedDayOfWeek] = useState(-100);
	const [selectedSizeBand, setSelectedSizeBand] = useState("NONE");
	const [selectedFacultyId, setSelectedFacultyId] = useState(-100);
	const [selectedDepartmentId, setSelectedDepartmentId] = useState(-100);
	const [selectedLectureFlags, setSelectedLectureFlags] = useState([-1, 0]);
	
	const ACTION_CONTAINER = {
	  display: "flex",
	  flexDirection: "column",
	  gap: "10px",
	  marginBottom: "16px",
	  marginTop:'20px',
	  marginLeft:'20px',
	  marginBottom:'0px'
	};

	const ACTION_CONTAINER_ROW = {
	  display: "flex",
	  alignItems: "center",
	  gap: "12px"
	};
	
	const DARK_FILTER_BOX = {
		  display: "flex",
		  flexDirection: "column",
		  width: "400px",
		  padding: "14px 16px 18px 16px",
		  background: "linear-gradient(180deg, #2b2f35 0%, #1f2329 100%)",
		  border: "1px solid rgba(255,255,255,0.08)",
		  borderRadius: "12px",
		  boxShadow: "0 8px 18px rgba(0,0,0,0.25)",
		  color: "#ffffff",
		  marginTop:'20px',
		  marginLeft:'20px',
		  marginRight:'20px'
		};

		const DARK_INPUT_ROW = {
		  display: "flex",
		  alignItems: "center",
		  height: "34px",
		  marginBottom: "10px"
		};

		const DARK_LABEL = {
		  display: "flex",
		  width: "120px",
		  fontSize: "12px",
		  fontWeight: "600",
		  letterSpacing: "0.3px",
		  color: "rgba(255,255,255,0.85)"
		};

		const DARK_SELECT = {
		  flexGrow: "1",
		  height: "30px",
		  borderRadius: "6px",
		  border: "1px solid rgba(255,255,255,0.18)",
		  background: "linear-gradient(180deg, #3a3f46 0%, #2b2f35 100%)",
		  color: "#ffffff",
		  fontSize: "12px",
		  padding: "0 10px",
		  outline: "none"
		};

		const DARK_CHECKBOX_ROW = {
		  display: "flex",
		  alignItems: "center",
		  gap: "20px",
		  margin: "10px 0",
		  fontSize: "12px",
		  paddingLeft: "10px"
		};

		const DARK_CHECKBOX_LABEL = {
		  display: "flex",
		  alignItems: "center",
		  color: "rgba(255,255,255,0.85)",
		  cursor: "pointer"
		};

		const DARK_BUTTON = {
		  display: "flex",
		  alignItems: "center",
		  justifyContent: "center",
		  height: "34px",
		  padding: "0 22px",
		  borderRadius: "17px",
		  border: "1px solid rgba(255,255,255,0.35)",
		  fontSize: "12px",
		  fontWeight: "600",
		  letterSpacing: "0.4px",
		  cursor: "pointer",
		  background: "linear-gradient(180deg, #4DA8FF 0%, #1C72D4 100%)",
		  color: "#ffffff",
		  boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
		  transition: "all 0.2s ease",
		  width:'180px'
		};

		const DARK_SPACER = {
		  backgroundColor: "transparent",
		  marginTop: "12px",
		  width: "100%",
		  flexGrow: "1"
		};

		const DARK_OPTION = {
		  backgroundColor: "#ffffff",
		  color: "#1e2a38",
		  fontSize: "12px"
		};
		
		
		const TOP_BUTTON_BAR = {
		  display: "flex",
		  alignItems: "center",
		  gap: "12px",
		  marginBottom: "14px"
		};

		const TOP_PILL_BUTTON = {
		  display: "flex",
		  alignItems: "center",
		  justifyContent: "center",
		  height: "34px",
		  padding: "0 22px",
		  borderRadius: "17px",
		  border: "1px solid rgba(255,255,255,0.18)",
		  fontSize: "12px",
		  fontWeight: "600",
		  letterSpacing: "0.4px",
		  cursor: "pointer",
		  background: "linear-gradient(180deg, #2b2f35 0%, #1f2329 100%)",
		  color: "#ffffff",
		  boxShadow: "0 6px 14px rgba(0,0,0,0.25)",
		  transition: "all 0.2s ease",
		  width:'180px'
		};
		
		const TOP_PILL_BUTTON_POWER = {
		  background: "linear-gradient(180deg, #3a3f46 0%, #2b2f35 100%)",
		  border: "1px solid rgba(255,255,255,0.25)"
		};

		const TOP_PILL_BUTTON_ACTIVE = {
		  background: "linear-gradient(180deg, #4DA8FF 0%, #1C72D4 100%)",
		  border: "1px solid rgba(255,255,255,0.35)",
		  boxShadow: "0 6px 16px rgba(0,0,0,0.35)",
		  color: "#ffffff"
		};

		const TOP_GHOST_PILL = {
		  display: "flex",
		  alignItems: "center",
		  justifyContent: "center",
		  height: "34px",
		  padding: "0 20px",
		  borderRadius: "17px",
		  border: "1px solid rgba(0,0,0,0.12)",
		  fontSize: "12px",
		  fontWeight: "500",
		  letterSpacing: "0.3px",
		  background: "linear-gradient(180deg, #f7f8fa 0%, #ffffff 100%)",
		  color: "#2a3442",
		  boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
		};

		
		const TOP_KPI_CHIP = {
		  display: "flex",
		  alignItems: "center",
		  justifyContent: "space-between",
		  height: "34px",
		  minWidth: "200px",
		  padding: "0 14px",
		  borderRadius: "10px",
		  border: "1px solid rgba(0,0,0,0.08)",
		  background: "linear-gradient(180deg, #f7f8fa 0%, #ffffff 100%)",
		  fontSize: "12px",
		  fontWeight: "600",
		  letterSpacing: "0.3px",
		  color: "#2a3442"
		};

		const TOP_KPI_LABEL = {
		  opacity: "0.65",
		  fontWeight: "500"
		};

		const TOP_KPI_VALUE = {
		  fontWeight: "700",
		  color: "#1e2a38"
		};
	
	const firstFilterRun = useRef(true);
	
	const sizeBands = [
		'1 - 4',
		'5 - 9',
		'10 - 19',
		'20 - 39',
		'40 - 59',
		'60 - 89',
		'90 - 149',
		'150 - 199',
		'200 - 249',
		'250 - 349',
		'350 - 449',
		'450 - 549',
		'550+'
	];
	
	const daysOfWeek = [
		{id:'0', name:'Sun'},
		{id:'1', name:'Mon'},
		{id:'2', name:'Tue'},
		{id:'3', name:'Wed'},
		{id:'4', name:'Thu'},
		{id:'5', name:'Fri'},
		{id:'6', name:'Sat'}
	];
	
	const hoursOfDay = [
		{id:'8', name:'08:00'},
		{id:'9', name:'09:00'},
		{id:'10', name:'10:00'},
		{id:'11', name:'11:00'},
		{id:'12', name:'12:00'},
		{id:'13', name:'13:00'},
		{id:'14', name:'14:00'},
		{id:'15', name:'15:00'},
		{id:'16', name:'16:00'},
		{id:'17', name:'17:00'}
	];
	
	const getDayOfWeek = (index) => {
		return daysOfWeek[parseInt(index)].name;
	}
	
	useEffect(() => {
		if(loaded === false){
			loadLists();
			setLoaded(true);
		}
		
	}, []);

	useEffect(() => {
		loadData();
	}, [processType]);
	
	useEffect(() => {
		loadData();
	}, [showExams]);
	
	const updateFilterBean = () => {
    	
    	let formData = {
        includeId: includeIds,
        excludeId: excludeIds
    	};
    	
       functions.submitAjax("/resolutionsoftwareplatform/" + setFilterBeanUrl, 
					formData, saveEnd, STRINGIFY, handleSubmitError);
    };
	
	useEffect(() => {

	  // 🔥 Prevent accidental filter POST on initial page load
	  if (firstFilterRun.current) {
	    firstFilterRun.current = false;
	    return;
	  }

	  // Build filter object
	  let formData = {
	    hourOfDay: selectedHourOfDay,
	    facultyId: selectedFacultyId,
	    departmentId: selectedDepartmentId,
	    dayOfWeek: selectedDayOfWeek,
	    weekId: selectedTeachingWeekId,
	    sizeBand: selectedSizeBand,
	    roomTypeFlags: selectedLectureFlags
	  };

	  // Save filter & then reload data
	  functions.submitAjax(
	    "/resolutionsoftwareplatform/setfilterbean/timetable",
	    formData,
	    loadDataDelayed,
	    STRINGIFY,
	    handleSubmitError
	  );

	}, [
	  selectedTeachingWeekId,
	  selectedHourOfDay,
	  selectedDayOfWeek,
	  selectedSizeBand,
	  selectedFacultyId,
	  selectedDepartmentId,
	  selectedLectureFlags
	]);
	
	 const handleSubmitError = (e) => {
			console.log(e);
			
		};
		
		const loadDataDelayed = () => {
			const timer = setTimeout(loadData, 1000);
		}
	
	const loadData = () => {
		loadDataAnnual();
		loadDataDayOfWeek();
		loadDataHourOfDay();
		loadDataSizeBand();
		loadDataFaculty();
		loadMaxMins();
	}
	
	
	const goTimetable = () => {
		history.push('/timetable');
	}
  
	const loadDataAnnual = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/annual?processtype=" + processType, null, populateDataAnnual);
	};
	
	const loadDataDayOfWeek = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/dayofweek?processtype=" + processType, null, populateDataDayOfWeek);
	};
	
	const loadDataHourOfDay = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/hourofday?processtype=" + processType, null, populateDataHourOfDay);
	};
	
	const loadDataSizeBand = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/sizeband?processtype=" + processType, null, populateDataSizeBand);
	};
	
	const loadDataFaculty = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/faculty?processtype=" + processType, populateDataFaculty, null);
	};
	
	const loadDataExamsAnnual = (values) => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/annual/exams?processtype=" + processType, null, populateDataAnnualExams, values);
	};
	
	const loadDataExamsDayOfWeek = (values) => {
		for(let i=0; i<values.length; i++){
			values[i].name = getDayOfWeek(values[i].name);
		}
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/dayofweek/exams?processtype=" + processType, null, populateDataDayOfWeekExams, values);
	};
	
	const loadDataExamsHourOfDay = (values) => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/hourofday/exams?processtype=" + processType, null, populateDataHourOfDayExams, values);
	};
	
	const loadDataExamsSizeBand = (values) => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/sizeband/exams?processtype=" + processType, null, populateDataSizeBandExams, values);
	};
	
	const loadDataExamsFaculty = (values) => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/faculty/exams?processtype=" + processType, null, populateDataFacultyExams, values);
	};
	
	const loadMaxMins = () => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/maxcount", setMaxCount, setMaxCount);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/mincount", setMinCount,setMinCount);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/maxsum", setMaxSum, setMaxSum);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/data/minsum", setMinSum,setMinSum);
	};
	
	const populateDataAnnual = (values) => {
		loadDataExamsAnnual(values);
	};
	
	const populateDataDayOfWeek = (values) => {
		loadDataExamsDayOfWeek(values);
	};
	
	const populateDataHourOfDay = (values) => {
		loadDataExamsHourOfDay(values);
	};
	
	const populateDataSizeBand = (values) => {
		loadDataExamsSizeBand(values);
	};
	
	const populateDataFaculty = (values) => {
		loadDataExamsFaculty(values);
	};
	
	const populateDataAnnualExams = (values, exams) => {
		setDataAnnualExams(mergeChartData(values, exams));
	};
	
	const populateDataDayOfWeekExams = (values, exams) => {
		console.log("Exam day of week");
		console.log(exams);
		for (let i=0; i<exams.length; i++){
	        exams[i].name = getDayOfWeek(parseInt(exams[i].id));
	   }
		setDataDayOfWeekExams(mergeChartData(values, exams));
	};
	
	const populateDataHourOfDayExams = (values, exams) => {
		setDataHourOfDayExams(mergeChartData(values, exams));
	};
	
	const populateDataSizeBandExams = (values, exams) => {
		setDataSizeBandExams(mergeChartData(values, exams));
	};
	
	const populateDataFacultyExams = (values, exams) => {
		setDataFacultyExams(mergeChartData(values, exams));
	};
	
	const loadLists = () => {
		
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/list/faculties", setFaculties, null);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/list/departments", setDepartments, null);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/timetable/list/teachingweeks", setTeachingWeeks, null);
	};
	
	useEffect(() => {
	  if (!loaded) return;
	  loadData();
	}, [loaded]);
	
	const getWhenMaxCount = () => {
		if(maxCount  && maxCount.weekCode != null){
			return 'WK' + maxCount.weekCode + ' (Day: ' + getDayOfWeek(maxCount.dayOfWeek) + ')';
		}
		else{
			return '';
		}
	};
	
	const getWhenMinCount = () => {
		if(minCount && minCount.weekCode != null){
			return 'WK' + minCount.weekCode + ' (Day: ' + getDayOfWeek(minCount.dayOfWeek) + ')';
		}
		else{
			return '';
		}
	};
	
	const getWhenMaxSum = () => {
		if(maxSum && maxSum.weekCode != null){
			return 'WK' + maxSum.weekCode + ' (Day: ' + getDayOfWeek(maxSum.dayOfWeek) + ')';
		}
		else{
			return '';
		}
	};
	
	const getWhenMinSum = () => {
		if(minSum && minSum.weekCode != null){
			return 'WK' + minSum.weekCode + ' (Day: ' + getDayOfWeek(minSum.dayOfWeek) + ')';
		}
		else{
			return '';
		}
	};

  // ------------- STYLES -------------
  const thisContainer = { display: "flex", width: "100%", height:"100vh", flexWrap: "wrap", marginBottom:'20px' };
  const mainContainer = { display: "flex", width: "calc(100% - 60px)", marginLeft:'60px', marginTop:'0px', flexWrap: "wrap", background: NON_HERO_BACKGROUND, paddingTop:'20px' };
  const chartTitle = {display:'flex', alignSelf:'center', marginBottom:"10px", fontSize:'12px', fontWeight:'bold', color:'#444'};
  const topRow = {display:'flex', width:'100%'};
  const topRowContent = {display:'flex', flexDirection:'column', flexGrow:'1'};
  const filterBox ={display:'flex', paddingTop:'20px', marginLeft:'20px', backgroundColor:'white', width:'400px', 
	flexDirection:'column',
		background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)",
		boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
		borderTopLeftRadius:"16px",
		borderBottomLeftRadius:"16px",
		height:"320px",
		marginTop:"20px",
		marginBottom:"20px",
		marginLeft:"20px"
	};
  
 
  const actionContainer = {
  	display:'flex',
  	flexDirection:'column'
  };
  
  const actionContainerRow = {
  	display:'flex',
  	width:"100%",
  	marginTop:"20px",
  	marginLeft:"10px"
  }
  
  const actionButton = {
  	display:'flex', width:"200px",
  	height:"40px",
  	margin:'0px',
  	alignItems:'center',
  	justifyContent:'space-around',
  	fontSize:'14px',
  	color:"white",
  	marginRight:"20px",
  	borderRadius:"10px",
  	cursor:'pointer',
	boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
	background: "linear-gradient(180deg, #3A3A3A 0%, #111 100%)"
  };
  
  const actionButtonSelected = {
  	display:'flex', width:"200px",
	boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
  	height:"40px",
  	margin:'0px',
  	alignItems:'center',
  	justifyContent:'space-around',
  	fontSize:'14px',
  	color:"white",
    background: "linear-gradient(180deg, #4DA8FF 0%, #1C72D4 100%)",
  	marginRight:"20px",
  	borderRadius:"10px",
  	cursor:'pointer',
	
  };
  
   const actionInfo = {
  	display:'flex', width:"200px",
  
  	backgroundColor:"darkgrey",
  	height:"40px",
  	margin:'0px',
  	alignItems:'center',
  	justifyContent:'space-around',
  	fontSize:'14px',
  	color:"white",
  	marginRight:"20px",
  	borderRadius:"10px"
  };
  
  const chartContainerLarge = {
    display: "flex",
    flexGrow:"1",
    marginLeft:"20px",
    flexDirection:'column',
	marginTop:"20px"
  };
  const chartContainer = {
    display: "flex",
    width: "calc(25% - 25px)",
    flexDirection:'column',
    marginLeft:"20px",
	marginTop:"20px",
	height:"calc(100vh - 540px)"
  };
  const chartDiv = {
    display: "flex",
    width: "100%",
    height: "calc(50vh - 100px)",
    backgroundColor: "#f4f4f4",
    border: "1px solid #ccc",
  };
  
  const getStyleShowEvents = () => {
  	if(processType === PROCESS_TYPE_COUNT){
  		return actionButtonSelected;
  	}
  	else{
  		return actionButton;
  	}
  };
  
  const getStyleShowLectureSize = () => {
  	if(processType === PROCESS_TYPE_SUM){
  		return actionButtonSelected;
  	}
  	else{
  		return actionButton;
  	}
  };
  
	const optionsFaculty = faculties.map((item, index) =>
		<option style={DARK_OPTION} value={item.id}>
			{item.name}
		</option>
	);
	
	const optionsDepartment = departments.map((item, index) =>
		<option style={DARK_OPTION} value={item.id}>
			{item.name}
		</option>
	);
	
	const optionsTeachingWeek = teachingWeeks.map((item, index) =>
		<option style={DARK_OPTION} value={item.id}>
			{item.code}
		</option>
	);
	
	const optionsDaysOfWeek = daysOfWeek.map((item, index) =>
		<option style={DARK_OPTION} value={item.id}>
			{item.name}
		</option>
	);
	
	const optionsHoursOfDay = hoursOfDay.map((item, index) =>
		<option style={DARK_OPTION} value={item.id}>
			{item.name}
		</option>
	);
	
	const optionsSizeBand = sizeBands.map((item, index) =>
		<option style={DARK_OPTION} value={item}>
			{item}
		</option>
	);
	
	const handleChangeTeachingWeek = (e) => {
			setSelectedTeachingWeekId(e.target.value);
	};
	
	const handleChangeFaculty = (e) => {
		setSelectedFacultyId(e.target.value);
	};
	
	const handleChangeDepartment = (e) => {
		setSelectedDepartmentId(e.target.value);
	};
	
	const handleChangeSizeBand = (e) => {
		setSelectedSizeBand(e.target.value);
	};
	
	const handleChangeDayOfWeek = (e) => {
		setSelectedDayOfWeek(e.target.value);
	};
	
	const handleChangeHourOfDay = (e) => {
		setSelectedHourOfDay(e.target.value);
	};
	
	const clearFilter = () => {
		refTeachingWeek.current.value = -100;
		refSizeBand.current.value = "NONE";
		refDayOfWeek.current.value = -100;
		refHourOfDay.current.value = -100;
		refFaculty.current.value = -100;
		refDepartment.current.value = -100;
		
		setSelectedTeachingWeekId(-100);
		setSelectedFacultyId(-100);
		setSelectedDepartmentId(-100);
		setSelectedSizeBand("NONE");
		setSelectedHourOfDay(-100);
		setSelectedDayOfWeek(-100);
		setSelectedLectureFlags([-1, 0]);
		
		let formData = {
      
  	};
  
    functions.submitAjax("/resolutionsoftwareplatform/clearfilterbean/timetable", 
					formData, loadDataDelayed, STRINGIFY, handleSubmitError);
	}
	
	const mergeChartData = (lectures = [], exams = []) => {
	  const result = [];

	  // CASE 1: Lectures exist ⇒ drive normal merge
	  if (lectures.length > 0) {
	    for (let lec of lectures) {
	      const examMatch = exams.find(ex => ex.name === lec.name);
	      result.push({
	        id: lec.id,
	        name: lec.name,
	        value: lec.value ?? 0,  // lecture base
	        exams: examMatch ? examMatch.value : 0
	      });
	    }

	    return result;
	  }

	  // CASE 2: No lectures but exams exist ⇒ build rows from exams
	  if (exams.length > 0) {
	    for (let ex of exams) {
	      result.push({
	        id: ex.id || ex.name, // anything stable
	        name: ex.name,
	        value: 0,             // IMPORTANT: create base bar for stacked series
	        exams: ex.value
	      });
	    }
	  }

	  return result;
	};

	
	const toggleFlag = (flag) => {
	  const num = Number(flag);

	  setSelectedLectureFlags((prev) =>
	    prev.includes(num)
	      ? prev.filter((f) => f !== num)
	      : [...prev, num]
	  );
	};
	
	


  // ------------- RENDER -------------
  return (
    <div style={thisContainer}>
    	<Header transitionHide={true}/>
      <LeftMenu />
      <div style={mainContainer}>
      	<div style={topRow}>
      		<div style={topRowContent}>
			<div style={ACTION_CONTAINER}>

			  {/* ROW 1 — EVENTS */}
			  <div style={ACTION_CONTAINER_ROW}>

			    {/* SHOW EVENTS */}
			    <div
			      style={{
			        ...TOP_PILL_BUTTON,
			        ...(processType === PROCESS_TYPE_COUNT ? TOP_PILL_BUTTON_ACTIVE : {})
			      }}
			      onClick={() => { setProcessType(PROCESS_TYPE_COUNT); }}
			    >
			      Show Events
			    </div>

			    {/* MAX EVENTS */}
			    <div style={TOP_KPI_CHIP}>
			      <span style={TOP_KPI_LABEL}>Max</span>
			      <span style={TOP_KPI_VALUE}>
			        {functions.formatNumber(maxCount?.value, 0)}
			      </span>
			      {getWhenMaxCount()}
			    </div>

			    {/* MIN EVENTS */}
			    <div style={TOP_KPI_CHIP}>
			      <span style={TOP_KPI_LABEL}>Min</span>
			      <span style={TOP_KPI_VALUE}>
			        {functions.formatNumber(minCount?.value, 0)}
			      </span>
			      {getWhenMinCount()}
			    </div>

			    {/* SHOW SVG PLANS */}
			    <div
			      style={{
			        ...TOP_PILL_BUTTON,
			        ...TOP_PILL_BUTTON_POWER
			      }}
			      onClick={goTimetable}
			    >
			      Show SVG Plans
			    </div>

			  </div>

			  {/* ROW 2 — LECTURE SIZE */}
			  <div style={ACTION_CONTAINER_ROW}>

			    {/* SHOW LECTURE SIZE */}
			    <div
			      style={{
			        ...TOP_PILL_BUTTON,
			        ...(processType === PROCESS_TYPE_SUM ? TOP_PILL_BUTTON_ACTIVE : {})
			      }}
			      onClick={() => { setProcessType(PROCESS_TYPE_SUM); }}
			    >
			      Show Lecture Size
			    </div>

			    {/* MAX LECTURE SIZE */}
			    <div style={TOP_KPI_CHIP}>
			      <span style={TOP_KPI_LABEL}>Max</span>
			      <span style={TOP_KPI_VALUE}>
			        {functions.formatNumber(maxSum?.value, 0)}
			      </span>
			      {getWhenMaxSum()}
			    </div>

			    {/* MIN LECTURE SIZE */}
			    <div style={TOP_KPI_CHIP}>
			      <span style={TOP_KPI_LABEL}>Min</span>
			      <span style={TOP_KPI_VALUE}>
			        {functions.formatNumber(minSum?.value, 0)}
			      </span>
			      {getWhenMinSum()}
			    </div>

			  </div>

			</div>

			    	<div style={{...chartContainerLarge, ...CARD_STYLE}}>
						<div style={CHART_CONTAINER_STYLE}>
					         <TimetableChart
									 	chartId="timetabledashboardannual"
									 	chartData={dataAnnualExams}
									 	showExams={showExams}
									 	width="100%"
									 	height="calc(100% - 20px)"
										//onClick={handleBarClick}
										color={OMNISCAN_CORPORATE_RED}
									/>
							</div>
							<div style={chartTitle}>
								Teaching Weeks
							</div>
			      </div>
			    </div>
				<div style={DARK_FILTER_BOX}>

				  {/* CHECKBOX FLAGS */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_CHECKBOX_ROW}>

				      {/* LECTURE FLAG */}
				      <label style={{ ...DARK_CHECKBOX_LABEL, paddingLeft: "10px" }}>
				        <input
				          type="checkbox"
				          checked={selectedLectureFlags.includes(0)}
				          onChange={() => toggleFlag(0)}
				          style={{ marginRight: "6px" }}
				        />
				        Learning
				      </label>

				      {/* CONFERENCE / PUBLIC FLAG */}
				      <label style={DARK_CHECKBOX_LABEL}>
				        <input
				          type="checkbox"
				          checked={selectedLectureFlags.includes(1)}
				          onChange={() => toggleFlag(1)}
				          style={{ marginRight: "6px" }}
				        />
				        Conference/Public
				      </label>

				      {/* SHOW EXAMS */}
				      <label style={DARK_CHECKBOX_LABEL}>
				        <input
				          type="checkbox"
				          checked={showExams}
				          onChange={(e) => setShowExams(e.target.checked)}
				          style={{ marginRight: "6px" }}
				        />
				        Exams
				      </label>

				    </div>
				  </div>

				  {/* TEACHING WEEK */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_LABEL}>
				      Teaching Week
				    </div>
				    <select ref={refTeachingWeek} style={DARK_SELECT} onChange={handleChangeTeachingWeek}>
				      <option style={DARK_OPTION} value="-100">{BASE_SELECT_FIRST_OPTION}</option>
				      {optionsTeachingWeek}
				    </select>
				  </div>

				  {/* SIZE BAND */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_LABEL}>
				      Size Band
				    </div>
				    <select ref={refSizeBand} style={DARK_SELECT} onChange={handleChangeSizeBand}>
				      <option style={DARK_OPTION} value="NONE">{BASE_SELECT_FIRST_OPTION}</option>
				      {optionsSizeBand}
				    </select>
				  </div>

				  {/* DAY OF WEEK */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_LABEL}>
				      Day Week
				    </div>
				    <select ref={refDayOfWeek} style={DARK_SELECT} onChange={handleChangeDayOfWeek}>
				      <option style={DARK_OPTION} value="-100">{BASE_SELECT_FIRST_OPTION}</option>
				      {optionsDaysOfWeek}
				    </select>
				  </div>

				  {/* HOUR OF DAY */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_LABEL}>
				      Hour Of Day
				    </div>
				    <select ref={refHourOfDay} style={DARK_SELECT} onChange={handleChangeHourOfDay}>
				      <option style={DARK_OPTION} value="-100">{BASE_SELECT_FIRST_OPTION}</option>
				      {optionsHoursOfDay}
				    </select>
				  </div>

				  {/* FACILITY */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_LABEL}>
				      Facility
				    </div>
				    <select ref={refFaculty} style={DARK_SELECT} onChange={handleChangeFaculty}>
				      <option style={DARK_OPTION} value="-100">{BASE_SELECT_FIRST_OPTION}</option>
				      {optionsFaculty}
				    </select>
				  </div>

				  {/* DEPARTMENT */}
				  <div style={DARK_INPUT_ROW}>
				    <div style={DARK_LABEL}>
				      Department
				    </div>
				    <select ref={refDepartment} style={DARK_SELECT} onChange={handleChangeDepartment}>
				      <option style={DARK_OPTION} value="-100">{BASE_SELECT_FIRST_OPTION}</option>
				      {optionsDepartment}
				    </select>
				  </div>

				  {/* CLEAR FILTER BUTTON */}
				  <div style={DARK_INPUT_ROW}>
				    <button
				      onClick={clearFilter}
				      style={{
				        ...DARK_BUTTON,
				        margin: "auto",
				        alignSelf: "center"
				      }}
				    >
				      Clear Filter
				    </button>
				  </div>

				  <div style={DARK_SPACER} />

				</div>

	      </div>
	
	      <div style={{...chartContainer, ...CARD_STYLE}}>
		  	<div style={CHART_CONTAINER_STYLE}>
	       	 	<TimetableChart
					 	chartId="timetabledashboarddayofweekorig"
					 	chartData={dataDayOfWeekExams}
					 	categoryKey="name"
					 	valueKey="value"
					 	width="100%"
					 	height="calc(100% - 20px)"
					 	showExams={showExams}
						//onClick={handleBarClick}
						color={OMNISCAN_CORPORATE_PINK}
					/>
					</div>
					<div style={chartTitle}>
						Day Of Week
					</div>
	      </div>
	
	      <div style={{...chartContainer, ...CARD_STYLE}}>
		  		<div style={CHART_CONTAINER_STYLE}>
		  	       	 <TimetableChart
					 	chartId="timetabledashboardhourofdayorig"
					 	chartData={dataHourOfDayExams}
					 	categoryKey="name"
					 	valueKey="value"
					 	width="100%"
					 	height="calc(100% - 20px)"
						//onClick={handleBarClick}
						color={OMNISCAN_CORPORATE_PINK}
						showExams={showExams}
					/>
					</div>
					<div style={chartTitle}>
						Hour Of Day
					</div>
	      </div>
	
	      <div style={{...chartContainer, ...CARD_STYLE}}>
		  	<div style={CHART_CONTAINER_STYLE}>
	       		<TimetableChart
	       		isSizeBand="true"
					 	chartId="timetabledashboardsizebandorig"
					 	chartData={dataSizeBandExams}
					 	categoryKey="name"
					 	valueKey="value"
					 	width="100%"
					 	height="calc(100% - 20px)"
						//onClick={handleBarClick}
						color={OMNISCAN_CORPORATE_PURPLE}
						showExams={showExams}
						type="bar"
					/>
					</div>
					<div style={chartTitle}>
						Size Band
					</div>
	      </div>
	      <div style={{...chartContainer, ...CARD_STYLE}}>
		  	<div style={CHART_CONTAINER_STYLE}>
	       		<TimetableChart
					 	chartId="timetabledashboardfacultyorig"
					 	chartData={dataFacultyExams}
					 	categoryKey="name"
					 	valueKey="value"
					 	width="100%"
					 	height="calc(100% - 20px)"
						//onClick={handleBarClick}
						color={OMNISCAN_CORPORATE_PURPLE}
						showExams={showExams}
						type="bar"
					/>
				</div>
					<div style={chartTitle}>
						Faculty/Department
					</div>
	      </div>
	    </div>
	   </div>
  );
}
